import './post_view.js.coffee'
Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.InstagramPostView extends Monitoring.Reports.DailyInsights.PostView
  preview: JST['backbone/templates/monitoring/reports/daily_insights/post_preview_instagram']

  customRender: =>
    @$('[data-view=post-preview]').append(@preview(@options.post))
    @sections.push(new Monitoring.Reports.DailyInsights.InstagramMetricsView(@options))
